import { render, staticRenderFns } from "./RetirementSheetPage.vue?vue&type=template&id=5a45e850&"
import script from "./RetirementSheetPage.vue?vue&type=script&lang=js&"
export * from "./RetirementSheetPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports